import _isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Styles from './EntityDrawer.scss';
import EntityDrawerAttributes from './EntityDrawerAttributes';
import EntityImages from './Images/EntityImages';

const EntityDrawer = (props) => {
    const { selectedEntity, isLoading } = props;

    const [displayExpandedImg, setDisplayExpandedImg] = useState(false);
    const [selectedImg, setSelectedImg] = useState(0);

    const getMarkupImageUrls = (entityData: any) => {
        const truesizecaptureIds = entityData.generic_data[0].fields.find(
            (field: any) => field.type === 'truesizecapture'
        ).value;
        const compositeUrls = truesizecaptureIds.map((id: string) => {
            return entityData.generic_data[0].captures.find(
                (capture: any) => capture.id === id
            ).compositeUrl;
        });
        return compositeUrls;
    };

    useEffect(() => {
        setSelectedImg(0);
        setDisplayExpandedImg(false);
    }, [selectedEntity]);

    const handleResizeImgDisplay = (doExpand: boolean, imgIndex: number) => {
        setDisplayExpandedImg(doExpand);
        setSelectedImg(imgIndex);
    };

    return (
        <React.Fragment>
            {displayExpandedImg && (
                <div
                    id="expanded-images-container"
                    className={Styles.expandedEntityImagesContainer}
                >
                    <EntityImages
                        images={selectedEntity.images}
                        loadedThumbnails={selectedEntity.thumbnails}
                        loadedMainImages={selectedEntity.mainImages}
                        isLoading={isLoading}
                        entityId={selectedEntity.entity_version_id}
                        containerHeight={Styles.expandedImgContainerHeight}
                        onCollapse={(imgIndex) =>
                            handleResizeImgDisplay(false, imgIndex)
                        }
                        initialImage={selectedImg}
                    />
                </div>
            )}
            <div id="entity-drawer" className={Styles.entityDrawer}>
                {selectedEntity &&
                    selectedEntity.images.length > 0 &&
                    !displayExpandedImg && (
                        <EntityImages
                            images={selectedEntity.images}
                            loadedThumbnails={selectedEntity.thumbnails}
                            loadedMainImages={selectedEntity.mainImages}
                            isLoading={isLoading}
                            entityId={selectedEntity.entity_version_id}
                            onExpand={(imgIndex) =>
                                handleResizeImgDisplay(true, imgIndex)
                            }
                            initialImage={selectedImg}
                        />
                    )}
                <EntityDrawerAttributes
                    selectedEntity={selectedEntity}
                    isLoading={isLoading}
                    clientId={selectedEntity.client_id[0]}
                />
            </div>
        </React.Fragment>
    );
};

EntityDrawer.propTypes = {
    selectedEntity: PropTypes.any,
    isLoading: PropTypes.bool,
};
export default EntityDrawer;
